module.exports = __webpack_public_path__ + "static/interview_map_02_ja-194401c3915dca3756b1b1f965124581.svg";